export default __webpack_public_path__ + "static/media/message.0de98644.png";